import * as React from 'react';
import { useHistory } from 'react-router';
import { Breadcrumb, Button, Modal, Toast } from '@roo/roo';
import utils from '@/utils/utils';
import { getCancelDetail, CancelDetailRes, UploadImageRes, postCancelUpdate } from './api';
import CancelTable from './components/CancelTabel';
import RejectModal from './components/RejectModal';
import { IServerResponse } from '@/utils/request';
import './index.scss';

const { useState, useEffect, useCallback } = React;

interface Params {
    id?: string;
    msgId?: string;
}

const ContractCancel: React.FC = () => {
    const [tableData, setTabelData] = useState<CancelDetailRes>();
    const [rejectModalShow, setRejectModalShow] = useState<boolean>(false);
    const history = useHistory();
    const fetchCancelDetail = useCallback(() => {
        const params = utils.urlParse() as Params;
        const { id = '', msgId = '' } = params;
        getCancelDetail({
            contractId: id,
            msgId,
        }).then(res => {
            setTabelData(res.data);
        });
    }, []);

    useEffect(() => {
        fetchCancelDetail();
    }, [fetchCancelDetail]);

    const handleCancel = () => {
        Toast.open({
            children: '请及时完成审核，逾期3天将自动回收',
            status: 'info',
            position: 'topCenter',
            duration: 2000,
            onClose: () => {
                history.goBack();
            },
        });
    };
    const handleConfirm = () => {
        Modal.confirm({
            title: '确定要解约吗？',
            status: 'info',
            showCancelButton: true,
            onConfirm: () => {
                const params = utils.urlParse() as Params;
                const { id = '', msgId = '' } = params;
                postCancelUpdate({
                    contractId: id,
                    type: 1,
                    msgId,
                });
                handleCancelSuccess();
            },
        });
    };
    const handleReject = () => {
        setRejectModalShow(true);
    };
    const handleCancelSuccess = () => {
        Toast.open({
            children: '解约成功，请联系平台回收门店',
            status: 'success',
            position: 'topCenter',
            duration: 2000,
            onClose: () => {
                history.goBack();
            },
        });
    };
    return (
        <div className="page contract-cancel">
            <Breadcrumb
                type="oblique"
                items={[
                    {
                        text: '消息中心',
                        onClick: () => {
                            history.push('/messageCenter');
                        },
                    },
                    {
                        text: '解约申请明细',
                    },
                ]}
            />
            <h1>
                代运营解约申请明细
                {tableData?.status === 0
                    ? null
                    : `（该申请已${tableData?.status === 1 ? '同意' : '拒绝'}）`}
            </h1>
            <CancelTable data={tableData} />
            {tableData?.status !== 0 ? null : (
                <div className="contract-btn">
                    <Button onClick={handleCancel}>暂不处理</Button>
                    <Button onClick={handleConfirm}>同意解约</Button>
                    <Button onClick={handleReject}>拒绝解约</Button>
                </div>
            )}
            {rejectModalShow ? (
                <RejectModal
                    onCancel={() => {
                        setRejectModalShow(false);
                    }}
                    onConfirm={(list, extReason: string) => {
                        const imgList: string[] = list.map(val => {
                            const res = val.response as IServerResponse<UploadImageRes>;
                            return res.data.url;
                        });
                        const params = utils.urlParse() as Params;
                        const { id = '', msgId = '' } = params;
                        postCancelUpdate({
                            contractId: id,
                            reason: extReason,
                            images: imgList,
                            type: 2,
                            msgId,
                        }).then(() => {
                            Toast.open({
                                children: '驳回成功，合同正常履约中！',
                                status: 'success',
                                duration: 2000,
                                position: 'topCenter',
                                onClose: () => {
                                    history.goBack();
                                },
                            });
                        });
                    }}
                />
            ) : null}
        </div>
    );
};

export default ContractCancel;
